var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tableCom',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"items":_vm.items,"fields":_vm.fields,"title":_vm.title,"goPath":_vm.goPath},on:{"search":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }